import { POINTS_FOR_DRAW, POINTS_FOR_WIN } from "../constants";

const calculatePoints = (wins, draws, pointsPerWin) => {
  if (!wins && !draws) {
    return 0;
  }

  if (!wins) {
    return draws * POINTS_FOR_DRAW;
  }

  if (!draws) {
    return wins * (pointsPerWin ?? POINTS_FOR_WIN);
  }

  return wins * (pointsPerWin ?? POINTS_FOR_WIN) + draws * POINTS_FOR_DRAW;
};

export default calculatePoints;
